// extracted by mini-css-extract-plugin
module.exports = {"labelReq":"styles-module_labelReq_18vyM"};